/* eslint-disable quotes */
import profilePhoto from '../images/tmp/story_profile.png';
import profilePhoto2 from '../images/tmp/story_profile_2.png';
import profilePhoto3 from '../images/tmp/story_profile_3.png';

export const fakeStoriesApi = [
  {
    "id": 1,
    "name": "Letisha Truly",
    "profile_img_url": profilePhoto2,
    "date": "2019-05-17",
    "trip_name": "Fun in the Sun with Epic Watersports",
    "trip_url": "fun-in-the-sun-with-watersport",
    "description": "I enjoyed this trip so much! I had fun in the sun with epic watersports.",
    "gallery_id": "fun123",
    "photos": [
      {
        "img_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/e6cec64f-f699-4de2-80c3-8cfe6d52b7c6.jpg",
        "thumbnail_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/e6cec64f-f699-4de2-80c3-8cfe6d52b7c6.jpg",
      },
      {
        "img_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/efc026ba-a64c-4a7f-a132-c6f2ece78ce3.jpg",
        "thumbnail_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/efc026ba-a64c-4a7f-a132-c6f2ece78ce3.jpg",
      },
    ]
  },
  {
    "id": 2,
    "name": "Jack Green",
    "profile_img_url": profilePhoto,
    "date": "2019-07-02",
    "trip_name": "Garden picnic cooking experience",
    "trip_url": "garden-picnic-cooking-experience",
    "description": "The food and scenery was great. 10/10 would try again.",
    "gallery_id": "fun456",
    "photos": [
      {
        "img_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/bf3bbe65-b131-4a77-a2a2-28a65a9b6eea.jpg",
        "thumbnail_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/bf3bbe65-b131-4a77-a2a2-28a65a9b6eea.jpg",
      },
      {
        "img_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/c2499060-a0a6-4e44-8bfc-2347a79d63df.jpg",
        "thumbnail_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/c2499060-a0a6-4e44-8bfc-2347a79d63df.jpg",
      },
    ]
  },
  {
    "id": 3,
    "name": "John Fares",
    "profile_img_url": profilePhoto3,
    "date": "2019-06-12",
    "trip_name": "Rainforest waterfall expedition",
    "trip_url": "rainforest-waterfall-expedition",
    "description": "The rainforest was beautiful and the waterfall was great. Highly recommended.",
    "gallery_id": "fun789",
    "photos": [
      {
        "img_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/6fa6d26c-77ca-48e3-8413-a7e3bad8a9d0.jpg",
        "thumbnail_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/6fa6d26c-77ca-48e3-8413-a7e3bad8a9d0.jpg",
      },
      {
        "img_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/545b5aa5-97f6-4efe-be86-eac0a5d9a2eb.jpg",
        "thumbnail_url": "https://fordadv-stg.s3.ap-southeast-1.amazonaws.com/images/tmp/details/gallery/545b5aa5-97f6-4efe-be86-eac0a5d9a2eb.jpg",
      },
    ]
  },
];